// extracted by mini-css-extract-plugin
module.exports = {"fixedLabelWidth":"AppSelection-fixedLabelWidth-2-YncY"};